import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {of, tap} from 'rxjs';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {Store} from '@ngrx/store';

import {Router} from "@angular/router";
import {ToastMessageOptions, MessageService} from "primeng/api";
import {ErrorMessageTypes, GetMessage} from "../../../global-config/utils/toast-messages.utils";

import {AppState} from "../../../shared/state/app.state";
import {
  cancelUserInvite, cancelUserInviteFailure, cancelUserInviteSuccess,
  inviteUser, inviteUserFailure, inviteUserSuccess,
  loadInvitedUsers, loadInvitedUsersFailure, loadInvitedUsersSuccess,

} from "./user-invite.action";
import {UserInviteService} from "../../data-access/user-invite.service";


@Injectable()
export class UserInviteEffects {

  loadInvitedUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadInvitedUsers),
      switchMap(() =>
        this.userInviteService.get()
          .pipe(
            map((userInvites) => loadInvitedUsersSuccess({userInvites: userInvites})),
            catchError((error) => of(loadInvitedUsersFailure({ error: GetMessage('LoadFailure', 'Invited Users') })))
          )
      )
    )
  );

  inviteUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(inviteUser),
      switchMap((action) =>
        this.userInviteService.invite(action.userInvite)
          .pipe(
            map((userInvite) => inviteUserSuccess({userInvite: userInvite, successMessage: GetMessage('AddSuccess', 'Invite User')})),
            catchError((error) => of(inviteUserFailure({ error: GetMessage('LoadFailure', 'Invite User') })))
          )
      )
    )
  );

  cancelUserInvite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(cancelUserInvite),
      switchMap((action) =>
        this.userInviteService.cancel(action.userInviteId)
          .pipe(
            map((userInvite) => cancelUserInviteSuccess({userInvite: userInvite, successMessage: 'Canceled Invite'})),
            catchError((error) => of(cancelUserInviteFailure({ error: 'Failed to Cancel Invite' })))
          )
      )
    )
  );

  toastSuccessMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        inviteUserSuccess
      ),
      tap(({ successMessage }) => {
          return this.messageService.add({
            severity: 'success',
            summary: successMessage,
          } as ToastMessageOptions)
        }
      )
    ),
    { dispatch: false }
  );

  toastErrorMessages$ = createEffect(() =>
      this.actions$.pipe(
        ofType(
          loadInvitedUsersFailure,
          inviteUserFailure
        ),
        tap(({ error }) => {
            return this.messageService.add({
              severity: 'error',
              summary: error,
            } as ToastMessageOptions)
          }
        )
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private router: Router,
    private messageService: MessageService,
    private userInviteService: UserInviteService,
  ) {}
}

